import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import { useCallback, useEffect, useState } from "react";
import FilterComponent from "./FilterComponent";

export default function TextMultiSelect({
  title,
  options,
  onChange = () => {},
}) {
  const [value, setValue] = useState(options);

  const onSelect = useCallback(
    (evt) => {
      const selectedValues = evt.target.value;
      onChange({ title, selectedValues });
      setValue(selectedValues);
    },
    [title, onChange]
  );

  useEffect(() => {
    onSelect({ target: { value: options } });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options]);

  return (
    <FilterComponent>
      <FormControl fullWidth variant="outlined">
        <InputLabel id={title.replace(" ", "_").toLowerCase() + "_label"}>
          {title}
        </InputLabel>
        <Select
          id={title.replace(" ", "_").toLowerCase() + "_select"}
          labelId={title.replace(" ", "_").toLowerCase() + "_label"}
          onChange={onSelect}
          aria-labelledby="data-selector"
          value={value}
          label={title}
          multiple={true}
        >
          {options?.map((option) => (
            <MenuItem key={option.name} value={option}>
              {option.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </FilterComponent>
  );
}
